import { FaCheckCircle } from "react-icons/fa";
import { useState } from "react";
import ImagePopup from "../../ImagePopup/index.js";

const PricingBlock = ({
  title,
  price,
  features,
  image,
  color,
  bottomImage = null,
}) => {
  const [open, setOpen] = useState(false);
  // console.log("color", color);
  return (
    <div
      className={`cpl-item ${color} border-clip`}
      style={{
        "--border-color": color,
        borderWidth: "2.56px",
        borderStyle: "solid",
        "--bg-color": "white",
      }}
    >
      <div
        className="cpl-header"
        style={{
          padding: "20px",
          backgroundColor: `${color}`,
          width: "100%",
          filter: "brightness(0.8)",
        }}
      >
        <p className="cpl-title">{title}</p>
      </div>

      <div className="cpl-item-content">
        <h5
          className="cpl-price"
          style={{ color: `${color}`, filter: "brightness(0.8)" }}
        >
          {price}
        </h5>

        <ul className="cpl-item-list">
          {features.map((feature, index) => (
            <li
              key={index}
              style={{ color: `${color}`, filter: "brightness(0.8)" }}
            >
              <span className="cpl-check-icon" style={{ color: `${color}` }}>
                <FaCheckCircle />
              </span>
              {feature}
            </li>
          ))}
        </ul>

        <button
          className="more-info-btn"
          onClick={() => setOpen(true)}
          style={{ backgroundColor: `${color}`, filter: "brightness(0.8)" }}
        >
          More Info
        </button>
        <p
          className="cpl-contact-text"
          style={{ color: `${color}`, filter: "brightness(0.8)" }}
        >
          Call or text for more information
        </p>
        {bottomImage && <img src={bottomImage} alt="bottom_image" />}
      </div>
      {open && <ImagePopup image={image} onClose={() => setOpen(false)} />}
    </div>
  );
};

export default PricingBlock;
